<template>
  <div class="w-100 position-sticky bg-white py-3" style="bottom:0px" v-if="getOutletTrxTotalItem>0">
    <div class="ga-container">
      <div class="bg-green px-3 py-3 radius-6 cursor-pointer" @click="goToCart()">
        <div class="row">
          <div class="col-8">
            <p class="mb-0 body-3-1 text-white lh-1">{{ `${getOutletTrxTotalItem} ${$pluralWord(getOutletTrxTotalItem,'Menu')}`}} </p>
            <p class="mb-0 text-16 font-lato text-white">{{ $formatCurrency(getOutletTrxTotal) }}</p>
            <p class="mb-0 body-3-3-2 text-white" v-if="hasSeparateTaxService">Incl. tax &amp; service</p>
          </div>
          <div class="col-4 text-right">
            <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_615_23)">
                <path
                  d="M0 3.07546C0 3.65923 0.484101 4.15757 1.05363 4.15757H5.86616L8.14428 19.7912C8.44329 21.813 9.51115 23.0802 11.5757 23.0802H28.1917C28.7471 23.0802 29.2311 22.6246 29.2311 22.0124C29.2311 21.4001 28.7471 20.9445 28.1917 20.9445H11.8177C11.0062 20.9445 10.5078 20.3749 10.3797 19.5064L10.1519 18.0114H28.2203C30.299 18.0114 31.3669 16.7299 31.6659 14.6939L32.8049 7.16184C32.8334 6.97674 32.8619 6.74893 32.8619 6.62079C32.8619 5.93735 32.3493 5.46748 31.5663 5.46748H8.32938L8.04461 3.65923C7.90224 2.56289 7.50356 2.00758 6.05126 2.00758H1.05363C0.484101 2.00758 0 2.50593 0 3.07546ZM10.3797 27.6934C10.3797 28.9891 11.4048 30 12.7005 30C13.982 30 15.0072 28.9891 15.0072 27.6934C15.0072 26.412 13.982 25.3868 12.7005 25.3868C11.4048 25.3868 10.3797 26.412 10.3797 27.6934ZM23.6925 27.6934C23.6925 28.9891 24.7319 30 26.0133 30C27.309 30 28.3341 28.9891 28.3341 27.6934C28.3341 26.412 27.309 25.3868 26.0133 25.3868C24.7319 25.3868 23.6925 26.412 23.6925 27.6934Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_615_23">
                  <rect width="32.8619" height="30" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  
  export default {
    computed:{
      ...mapGetters(['getOutletTrxTotal','getOutletTrxTotalItem','getOutletTrxDisplayTaxService','getMerchant']),
      hasSeparateTaxService(){
        return this.getOutletTrxDisplayTaxService > 0
      },
      pos_code() {
        return this.$route.params.pos_code
      },
    },
    methods:{
      goToCart() {
        let route = {
          name: 'PosCart',
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code
          }
        } 
        this.$router.push(route)
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/pos/FloatOrderSummary.vue